import { JRCTypography } from 'components/JRCTypography/JRCTypography';
import styled from 'styled-components';
import { StyledInput } from '../JRCStyledInput';

export const StyledFieldWrapper = styled.fieldset<{ margin?: string; width?: string }>`
    margin: ${(props) => (props.margin !== undefined ? props.margin : '12px 0px')} !important;
    ${(props) => props?.width && `width: ${props.width} !important;`}
`;

export const Required = styled(JRCTypography).attrs(() => ({ size: 's' }))<{ error: boolean }>`
    color: ${(props) => (props.error ? props.theme.color.orange : props.theme.color.grey4)};
    transition: color 0.4s;
`;

export const LabelWrapper = styled.div`
    display: flex;
    gap: 10px;
    justify-content: space-between;
    align-items: end;
    width: 100%;
    padding-right: 5px;
`;

export const InputTextRawStyled = styled(StyledInput)`
    width: '100%';
`;
